/**
 * Created by Elad_Swissa on 7/20/15.
 */
export var ArticleType;
(function (ArticleType) {
    ArticleType[ArticleType["ARTICLE"] = 100] = "ARTICLE";
    ArticleType[ArticleType["FEATURE_REQUEST"] = 110] = "FEATURE_REQUEST";
    ArticleType[ArticleType["KNOWN_ISSUE"] = 120] = "KNOWN_ISSUE";
    ArticleType[ArticleType["VIDEO"] = 130] = "VIDEO";
})(ArticleType || (ArticleType = {}));
//# sourceMappingURL=article-type.enum.js.map